function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M181.2 116.4l-16-12-17.9 23.8c-1.8-.4-3.7-.6-5.6-.6-13.7 0-24.8 11.1-24.8 24.8s11.1 24.8 24.8 24.8 24.8-11.1 24.8-24.8c0-4.4-1.2-8.6-3.2-12.2l17.9-23.8zM146.7 14.2h-9.9C61.4 14.2 0 75.2 0 150.2V163h28.3v-12.8-1.4h14.1v-14.2h-13c2.9-19.7 11.2-38.1 24.3-53.5l9.7 10.7L74 82.3 63.7 70.9c19.6-17.8 44.5-27.8 70.9-28.3V57h14.2V42.6c26.4.5 51.3 10.4 70.8 28.1l-10.9 12.1 10.6 9.5 10.2-11.4c13.2 15.5 21.6 34 24.5 53.8h-13.1v14.2h14.2V163h28.3v-12.8c.1-75-61.3-136-136.7-136z"
})));